import { useEffect, useState } from "react";
import ShimmerScreen from "../../../Layouts/ShimmerScreen";
import "./DetailPageDiscussComponent.scss";
import DiscussCommentBlockComponent from "./DiscussCommentBlock/DiscussCommentBlockComponent";
import DiscussCommentReplyComponent from "./DiscussCommentReply/DiscussCommentReplyComponent";
import _ from "lodash";
import { useDispatch, useSelector } from "react-redux";
import { fetchCommentData, fetchCommentDataClear, postCommentData, postCommentDataClear, postLikeDisLikeData } from "../../../../redux/discuss/actions";
import { SessionKeys } from "../../../../utils/AppUtils";
import moment from "moment";

const DetailPageDiscussComponent = (props) => {

    const {
        id, code, type, source,isMobile
    } = props

    const dispatch = useDispatch();
    const commentData = useSelector(state => state.discuss.fetchComment)
    const sendCommentData = useSelector(state => state.discuss.sendComment)
    const likeDislikeCmtData = useSelector(state => state.discuss.likeDisLikeComment)
    const [isLoading, setIsLoading] = useState(false);

    const [commentBlock, setCommentBlock] = useState([
        {
            commentId: 1,
            commentorName: 'Lyle Kauffman (P-1)',
            commentDays: '5 days ago',
            commentData: "This is an interesting course. I find value in the free aspect of it. I thought the course related videos were very effective.",
            thumbsUpCount: 6,
            thumbsDownCount: 0,
            parentCommentId: 0,
            sameParent: false,
            enableReply: false,
            isSelfLike: false,
            isSelfDisLike: false,
            isLoading: true,
            subComment: [
                {
                    commentId: 2,
                    commentorName: 'Lyle Kauffman (C-1)',
                    commentDays: '5 days ago',
                    commentData: "This is an interesting course. I find value in the free aspect of it. I thought the course related videos were very effective.",
                    thumbsUpCount: 6,
                    thumbsDownCount: 0,
                    parentCommentId: 1,
                    sameParent: true,
                    enableReply: false,
                    isSelfLike: false,
                    isSelfDisLike: false,
                    isLoading: true,
                    subComment: [
                        {
                            commentId: 3,
                            commentorName: 'Lyle Kauffman (C-1 GC-1)',
                            commentDays: '5 days ago',
                            commentData: "This is an interesting course. I find value in the free aspect of it. I thought the course related videos were very effective.",
                            thumbsUpCount: 6,
                            thumbsDownCount: 0,
                            sameParent: false,
                            enableReply: false,
                            isSelfLike: false,
                            isSelfDisLike: false,
                            isLoading: true,
                            parentCommentId: 2,
                        }
                    ]
                },
            ]
        },
    ])
    const [isSendingChat, setIsSendingChat] = useState(false)

    useEffect(() => {
        console.log('id', id)
        console.log('source', source)
        console.log('code', code)
    }, [id, code, source])

    useEffect(() => {
        if (id !== '' && source !== '') {
            fetchCommentForDiscuss()
        }
    }, [dispatch, id, source])

    useEffect(() => {
        console.log('CommentData', commentData)
        if (!_.isEmpty(commentData)) {
            if (commentData.status === 'success') {
                const payload = commentData.payload.payload;
                if (!_.isEmpty(payload)) {
                    let newArr = loopCommentBlock([], 1, payload);
                    console.log(newArr)
                    setCommentBlock(newArr)
                } else {
                    setCommentBlock([])
                }
            } else {
                setCommentBlock([])
            }
            setIsLoading(false);
            dispatch(fetchCommentDataClear())
        }
    }, [commentData])

    useEffect(() => {
        console.log('Like DisLike CommentData', likeDislikeCmtData)
        if (!_.isEmpty(likeDislikeCmtData)) {
            if (likeDislikeCmtData.status === 'success') {
                fetchCommentForDiscuss()
            }
            // dispatch(postCommentDataClear())
        }
    }, [likeDislikeCmtData])

    useEffect(() => {
        console.log('Send CommentData', sendCommentData)
        if (!_.isEmpty(sendCommentData)) {
            if (sendCommentData.status === 'success') {
                fetchCommentForDiscuss()
            }
            setIsSendingChat(false)
            dispatch(postCommentDataClear())
        }
    }, [sendCommentData])

    const loopCommentBlock = (newArr, level, data, parentCommentId = 0) => {
        console.log(newArr, data)
        for (let p of data) {
            level = level ? level : 1
            // console.log(p);
            p.level = level;
            let cmtArr = []
            let cmtBlock = formatCommentBlock(p, parentCommentId)
            console.log(cmtBlock)
            if (!_.isEmpty(p.sub_comments)) {
                // console.log(p.sub_comments)
                let subCmtBlock = loopCommentBlock(cmtArr, level + 1, p.sub_comments, cmtBlock.commentId)
                console.log(subCmtBlock)
                cmtBlock.subComment = subCmtBlock
            }
            newArr.push(cmtBlock);
        }
        return newArr;
    }

    const formatCommentBlock = (data, parentCommentId) => {
        let altText = `${data.user_details.first_name.substr(0, 1)}`;
        if (data.user_details.last_name) {
            altText = altText + data.user_details.last_name.substr(0,1);
        }
        return {
            commentId: data.comment_id,
            commentorName: `${data.user_details.first_name} ${data.user_details.last_name}`,
            commentorImgURL: data.user_details.user_profile,
            commentorAltText: altText,
            commentDays: data.created_date ? moment.unix(data.created_date).fromNow() : '',
            commentData: data.comment,
            thumbsUpCount: data.like,
            thumbsDownCount: data.dislike,
            parentCommentId: parentCommentId ? parentCommentId : 0,
            level: data.level,
            sameParent: false,
            enableReply: false,
            hideReply: data.level >= 3 ? true : false,
            isSelfLike: data.is_self_like,
            isSelfDisLike: data.is_self_dislike,
            isLoading: false,
            subComment: []
        }
    }

    const fetchCommentForDiscuss = () => {
        if (id && type && source) {
            setIsLoading(true);
            dispatch(
                fetchCommentData({
                    module: 'fetchComment',
                    postData: {
                        token: isMobile ? localStorage.getItem(SessionKeys.API_TOKEN): localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
                        entity_id: id,
                        entity_type: type,
                        origin: source
                    }
                })
            )
        }
    }

    const postCommentForEntity = (comment, parentId = 0) => {
        if (id && origin) {
            console.log(comment, parentId)
            dispatch(
                postCommentData({
                    module: 'postComment',
                    postData: {
                        token: isMobile ? localStorage.getItem(SessionKeys.API_TOKEN):localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
                        entity_id: id,
                        entity_type: type,
                        origin: source,
                        comment: comment,
                        parent_comment_id: parentId
                    }
                })
            )
            setIsSendingChat(true)
        }
    }

    const replyAction = (commentId) => {
        console.log(commentId)
        const cmtBlock = markEnableReply(commentId, _.cloneDeep(commentBlock))
        setCommentBlock(cmtBlock)
    }

    const markEnableReply = (commentId, blockArr) => {
        for (let block of blockArr) {
            if (block.commentId === commentId) {
                block.enableReply = true;
            } else {
                block.enableReply = false;
                if (block.subComment) {
                    markEnableReply(commentId, block.subComment)
                }
            }
        }
        return blockArr
    }

    const likeAction = (commentId, type) => {
        console.log(commentId, type)
        dispatch(
            postLikeDisLikeData({
                module: 'postLikeDisLike',
                postData: {
                    token: isMobile ? localStorage.getItem(SessionKeys.API_TOKEN): localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
                    comment_id: commentId,
                    reaction: type,
                }
            })
        )
    }

    const renderDiscussHeader = () => {
        return (
            <div className="discuss-header">
                <div className="sort-share">
                    <div className="sort-share-div">
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M4.16666 10C4.16666 9.53978 4.53975 9.16669 4.99999 9.16669H15C15.4602 9.16669 15.8333 9.53978 15.8333 10C15.8333 10.4603 15.4602 10.8334 15 10.8334H4.99999C4.53975 10.8334 4.16666 10.4603 4.16666 10Z" fill="#6941C6"/>
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M1.66666 5.00002C1.66666 4.53978 2.03975 4.16669 2.49999 4.16669H17.5C17.9602 4.16669 18.3333 4.53978 18.3333 5.00002C18.3333 5.46026 17.9602 5.83335 17.5 5.83335H2.49999C2.03975 5.83335 1.66666 5.46026 1.66666 5.00002Z" fill="#6941C6"/>
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M6.66666 15C6.66666 14.5398 7.03975 14.1667 7.49999 14.1667H12.5C12.9602 14.1667 13.3333 14.5398 13.3333 15C13.3333 15.4603 12.9602 15.8334 12.5 15.8334H7.49999C7.03975 15.8334 6.66666 15.4603 6.66666 15Z" fill="#6941C6"/>
                        </svg>
                        <span>Sort</span>
                    </div>
                    <div className="sort-share-div">
                        <img src="/images/share-icon.svg" alt="" />
                        <span>Share</span>
                    </div>
                </div>
                {/* <button className="btn btn-login">
                    Login to comment
                    <img src="/images/login-icon.svg" alt="" />
                </button> */}
            </div>
        )
    }

    const renderDiscussCMT = (commentData, count) => {
        return (
            <div>
                {
                    commentData.map((c, i) => {
                        return (
                            <div className={`single-block-discuss com-${count} mt-3`}>
                                <DiscussCommentBlockComponent 
                                    index={i}
                                    {...c}
                                    replyAction={replyAction}
                                    likeAction={likeAction}
                                    avtarAction={() => { }}
                                    isLoading={isLoading}
                                />
                                {
                                    c.enableReply ?
                                    <div className={`single-block-discuss com-${count + 1} mt-3`}>
                                        <DiscussCommentReplyComponent 
                                            parentCommentId={c.commentId}
                                            sendCommentData={postCommentForEntity}
                                            isUploadingData={isSendingChat}
                                            isLoading={isLoading}
                                        />
                                    </div>
                                    : ""
                                }
                                {
                                    !_.isEmpty(c?.subComment)
                                    ?
                                        renderDiscussCMT(c?.subComment, count + 1)
                                    :
                                    ""
                                }
                            </div>
                        )
                    })
                }
            </div>
        )
    }

    const renderDiscussBody = () => {
        return (
            <div className="discuss-body">
                <div className="discuss-reply-block">
                    <DiscussCommentReplyComponent 
                        parentCommentId={0}
                        sendCommentData={postCommentForEntity}
                        isUploadingData={isSendingChat}
                    />
                </div>
                {renderDiscussCMT(commentBlock, 1)}
            </div>
        )
    }
    return (
        <>
            <div className="discuss-section">
                {/* {renderDiscussHeader()} */}
                {renderDiscussBody()}
            </div>
        </>
    )
}

export default DetailPageDiscussComponent